import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";

import HeaderNavAdmin from "../../HeaderFotter/Header/AdminHeader.js";
import Fotter from "../../HeaderFotter/Fotter/Fotter.js";
import BlurryCursor from "../../Dependence/Cursor/cursor.jsx";
import FixedNav from "../../HeaderFotter/FixedNav/Fixednav.js";
import axiosInstance from "../../../axiosInstance.js";
import { ColorRing } from "react-loader-spinner";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

const sizes = {
  desktop: 1024,
  tablet: 768,
  phone: 576,
};

const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label] / 16}em) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 1.5;
  font-size: 20px;
  font-weight: 300;
  color: #111;
`;

const Section = styled.section`
  padding: 0 50px;
  padding-bottom: 100px;
  max-width: 1330px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  /* Đảm bảo padding không thay đổi kích thước của div */
  box-sizing: border-box;

  ${media.desktop`
    padding: 50px 30px; // ví dụ thay đổi padding trên desktop nhỏ
  `}
  ${media.tablet`
    padding: 20px 20px; // thay đổi padding trên tablet
  `}
  ${media.phone`
    padding: 10px 10px; // thay đổi padding trên điện thoại
    padding-bottom: 100px; // giảm padding bottom trên điện thoại
  `}
`;

const MiddleLink = ({ token }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState({});

  useEffect(() => {
    setIsLoading(true);
    const fetchProtectedData = async () => {
      try {
        const response = await axiosInstance.get("/auth/protected", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUser(response.data.user);
      } catch (error) {
        localStorage.removeItem("token");
        navigate("/login");
        // window.location.href = '/login'; // Redirect to login page
      } finally {
        setIsLoading(false);
      }
    };

    if (token) {
      fetchProtectedData();
    }
  }, [token]);

  return (
    <Container className="content">
      {/* headder */}
      <HeaderNavAdmin user={user}/>

      {/* Section 1 */}
      <Section
        className="our-teams opacity-1 bg-mask"
        // style={{ paddingTop: "100px" }}
      >
        <p className="text-center uppercase font-bold text-clamp-50">
          List Test
        </p>
        <div>
          <div className="pl-5">
            {/* <p className="text-center uppercase font-bold text-clamp-50">
              Bài 1
            </p> */}
            <div className="flex justify-center">
              <p>
                <strong>Designer Test: </strong> <a href="/designtest">Here</a>{" "}
                <br />
                <strong>Idea Test: </strong> <a href="/ideatest">Here</a>
              </p>
            </div>
          </div>
        </div>
      </Section>

      <Fotter></Fotter>

      <FixedNav />
      <BlurryCursor />

      {/* <ToastContainer /> */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgb(75 81 99 / 80%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <ColorRing
            height={70}
            width={70}
            color="#4fa94d"
            ariaLabel="loading-indicator"
          />
        </div>
      )}
    </Container>
  );
};

export default MiddleLink;
